import { GLYPH_OWN_SIZE } from 'components/buttons/buttonStyle';
import { Button } from 'components/ui/button';
import { Tooltip } from 'components/ui/tooltip';
import { ReactNode } from 'react';
import { cn } from 'utils/cn';

/** A bordered strip of the icon actions over an invoice item table. */
export const ItemActionGroup = ({ children }: { children: ReactNode }) => (
    <div className="bg-paper border-divider text-fg flex gap-1 rounded-md border p-1">{children}</div>
);

/**
 * One icon action of an {@link ItemActionGroup}, named by `label`, which defaults to the tooltip. The
 * tooltip sits on a span: a disabled button fires no pointer events.
 */
export const ItemActionButton = ({
    tooltip,
    label = tooltip,
    disabled,
    onClick,
    children,
}: {
    tooltip: string;
    label?: string;
    disabled?: boolean;
    onClick: () => void;
    children: ReactNode;
}) => (
    <Tooltip content={tooltip} side="bottom">
        <span className="inline-flex">
            <Button
                variant="ghost"
                size="icon-sm"
                className={cn(GLYPH_OWN_SIZE, 'size-[30px] rounded-[4px]')}
                aria-label={label}
                disabled={disabled}
                onClick={onClick}
            >
                {children}
            </Button>
        </span>
    </Tooltip>
);
